import React, { Component } from 'react'
import '../style/Nav.css'
import Logo from '../assets/logo.png'
import {
    Link
} from 'react-router-dom';
export class Nav extends Component {
    render() {
        return (
            <div id="nav">
                <Link to="/">  <img src={Logo} alt="" id="navLogo" /></Link>
                <div id="navLinks">
                    <Link to="/"><span className="nav-link">Home</span></Link>
                    <Link to="/buy"><span className="nav-link">Buy</span></Link>
                    <Link to="/explore"><span className="nav-link">Explore</span></Link>
               
                </div>
            </div>
        )
    }
}

export default Nav
